import { type FunctionalComponent, h } from '@stencil/core';
import type { IFiltersConditional } from '../types/subcomponents-types.type';

const wrapper = (child: HTMLElement, labelProvider: CallableFunction) => {
    return (
      <div class="filtration__mobile">
        <se-filtration
          item={labelProvider('tab.filter-by', 'Filter by')}
          collapsed={false}
        >
          { child }
        </se-filtration>
      </div>
    );
};

export const FiltersConditionalWraper: FunctionalComponent<IFiltersConditional> = (props) => {
    const { mobileFilterButton, mobileView, child, labelProvider } = props;

    return (mobileFilterButton && mobileView ? wrapper(child, labelProvider) : child);
};
